export default {
  form: {
    header: {
      label: 'Encabezado',
      placeholder: 'Encabezado',
    },
    sub_header: {
      label: 'Subencabezado',
      placeholder: 'Subencabezado',
    },
    description: {
      label: 'Descripción',
      placeholder: 'Descripción',
    },
    qr_code_header: {
      label: 'Encabezado del cuadro UI',
      placeholder: 'Encabezado del cuadro UI',
    },
    qr_code_description: {
      label: 'Descripción del cuadro UI',
      placeholder: 'Descripción del cuadro UI',
    },
    footer: {
      label: 'Texto del pie',
      placeholder: 'Introduce el texto del pie',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Seleccionar URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Color primario',
    },
    background_color: {
      label: 'Color de fondo',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Error al cargar el folleto',
  },
};
